export const Heading = {
  defaultProps: {
    size: "md",
  },
}
